/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lp_Login_Browsetitle1Inputs */

const en_lp_login_browsetitle1 = /** @type {(inputs: Lp_Login_Browsetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse opportunities`)
};

/**
* | output |
* | --- |
* | "Browse opportunities" |
*
* @param {Lp_Login_Browsetitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lp_login_browsetitle1 = /** @type {((inputs?: Lp_Login_Browsetitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lp_Login_Browsetitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lp_login_browsetitle1(inputs)
});
export { lp_login_browsetitle1 as "lp_login_browseTitle" }